import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { Companies, GetRamiVitaResponse, GetRiskLevelsResponse } from 'models';
import { Observable } from 'rxjs';
import { DirectSearchService } from 'src/_services';
import { ApiService } from 'src/_utility/api';
import { TutorService } from 'src/app/_tutor/tutor.service';
import { BtnComponent } from 'src/app/components/utilities/btn/btn.component';
import { ObsWithLoadingPipe } from "../../../../_utility/obs-with-loading.pipe";

@Component({
  selector: 'app-direct-search-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    BtnComponent,
    MatProgressSpinnerModule,
    ObsWithLoadingPipe
],
  templateUrl: './direct-search-form.component.html',
  styleUrl: './direct-search-form.component.css'
})
export class DirectSearchFormComponent implements OnInit {

  @Input() isResultsShown: boolean = false;

  companies$: Observable<Companies> = undefined;
  ramiVita$: Observable<GetRamiVitaResponse[]> = undefined;
  riskLevels$: Observable<GetRiskLevelsResponse[]> = undefined;

  selectedCompany: string = undefined;
  selectedExpYear: number = undefined;
  selectedRamoVita: string = undefined;
  selectedRiskLevel: string = undefined;
  nameTyped: string = undefined;

  isLoadingProducts: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private directSearch: DirectSearchService,
    private tutor: TutorService,

  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      // Company from url query string
      const _company = params.get('Company');
      if(_company != null && _company != '') {
        this.selectedCompany = _company ?? null;
      }

      // Expiration year from url query string
      const _expire = params.get('Expire');
      if(_expire != null && _expire != '') {
        this.selectedExpYear = parseInt(_expire) ?? null;
      }

      //Ramo vita from url query string
      const _class = params.get('Class');
      if(_class != null && _class != '') {
        this.selectedRamoVita = _class ?? null;
      }

      //Risk grade from url query string
      const _risk = params.get('Risk');
      if(_risk != null && _risk != '') {
        this.selectedRiskLevel = _risk ?? null;
      }

      //Product name from url query string
      const _name = params.get('Name');
      if(_name != null && _name != '') {
        this.nameTyped = _name;
      }

      // Se ho dei params nella url allora carico i prodotti
      if (!this.isResultsShown && this.isWithParamSelected()) {
        this.loadSearch();
      }
    })

    this.companies$ = this.api.getCompanies();
    this.ramiVita$ = this.api.getRamiVita();
    this.riskLevels$ = this.api.getRiskLevels();
  }

  isWithParamSelected(): boolean {
    return (
      this.selectedCompany != null && this.selectedCompany != 'null' ||
      this.selectedExpYear != null ||
      this.selectedRamoVita != null && this.selectedRamoVita != 'null' ||
      this.selectedRiskLevel != null && this.selectedRiskLevel != 'null' ||
      this.nameTyped != null && this.nameTyped != 'null'
    )
  }

  getExpirationYears(): number[] {
    // Per il momento mettiamo come anni di scadenza i prossimi x anni (definito da expirationLimit)
    const expirationLimit = 20;
    let years = [];
    let currYear = new Date().getFullYear();
    for(let i = currYear; i <= (currYear + expirationLimit); i++) {
      years.push(i);
    }

    return years
  }

  isSearchBtnDisabled(): boolean {
    return (this.selectedCompany == null && this.selectedExpYear == null && this.selectedRamoVita == null && this.selectedRiskLevel == null && (this.nameTyped == null || this.nameTyped == ''))
  }

  loadSearch() {
    if(!this.isLoadingProducts && !this.isSearchBtnDisabled()) {
      this.isLoadingProducts = true;

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          Company: this.selectedCompany,
          Expire: this.selectedExpYear?.toString(),
          Class: this.selectedRamoVita,
          Risk: this.selectedRiskLevel,
          Name: this.nameTyped
        },
        queryParamsHandling: 'merge',
        skipLocationChange: false
      });
 
      this.directSearch.setSearchResult(null);

      const input = {
        Companies: this.selectedCompany != null && this.selectedCompany != 'null' ? [this.selectedCompany] : [],
        Classes: this.selectedRamoVita != null && this.selectedRamoVita != 'null' ? [this.selectedRamoVita] : [],
        Risks: this.selectedRiskLevel != null && this.selectedRiskLevel != 'null' ? parseInt(this.selectedRiskLevel): null,
        Expire: (typeof this.selectedExpYear === 'string' && (this.selectedExpYear as string) == 'null') ? null : this.selectedExpYear,
        Name: this.nameTyped,
        bgColor: "#e6b8b7",
        txtColor: "#05285b"
      }

      this.directSearch.setSearchInput(input);
      this.directSearch.loadSearch(input, this.searchLoaded.bind(this));

    }
  }

  searchLoaded() {
    this.isLoadingProducts = false;
  }

}
